import React from 'react'

interface LoadingStateContextProps {
  loadingState: boolean | null
  /**
   * `message` names the action being waited on ("Auto-filling the week…") and
   * is shown under the spinner. Optional, so every existing single-argument
   * caller keeps the generic wording.
   */
  setLoadingState: (LoadingState: boolean, message?: string) => void
  loadingMessage?: string
}

const LoadingStateContext = React.createContext<LoadingStateContextProps>({
  loadingState: null,
  setLoadingState: () => {},
})

export const LoadingStateProvider = LoadingStateContext.Provider
export default LoadingStateContext
